import React from 'react'

const ClientNameInput = props => {
  return (
    <div className='u-size1of2 u-paddingLeft12gu setup-form-inputs'>
      <div className='u-marginBottom6gu'>
        <label
          htmlFor='client-name'
          className='u-textSizeMsrp1 u-marginBottom3gu u-textColorBrand Form-label'>
          Client Name (Optional)
        </label>
        <input
          type='text'
          id='client-name'
          className='Input'
          name='input-name'
          data-testid='client-name'
          onChange={e => {
            localStorage.setItem('clientName', e.target.value)
          }}
        />
      </div>
      <div className='ButtonRow u-marginBottom10gu u-flex u-flexJustifyBetween'>
        <a
          className='setup-button-guide u-paddingHoriz9gu Button Button--primary'
          data-analytics='RIG-open-guide-button'
          href={props.welcomeUrl}
          role='button'>
          Open Guide
        </a>
      </div>
    </div>
  )
}

export default ClientNameInput
